import type { ReactNode } from "react";

import type { FontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { StyledBadgeContainer } from "./styles";

type BadgeSize = "small" | "large";

type BadgeProps = {
    text: string;
    dataAutomationType: string;
    size?: BadgeSize;
    icon?: ReactNode;
    onClick?: VoidFunction;
    bgColor?: string;
};

const SIZE_CONFIG: Record<BadgeSize, { padding: string; fontVariant: FontVariant }> = {
    small: { padding: "2px 6px", fontVariant: "queryBar1" },
    large: { padding: "5px 8px", fontVariant: "input2" },
};

const TagsBadge = ({
    text,
    dataAutomationType,
    size = "large",
    icon,
    onClick,
    bgColor = colorsPalettes.blue["100"],
}: BadgeProps) => {
    const { padding, fontVariant } = SIZE_CONFIG[size];

    return (
        <StyledBadgeContainer
            data-automation="badge"
            data-automation-type={dataAutomationType}
            background={bgColor}
            padding={padding}
            borderRadius="4px"
            gap="4px"
            alignItems="center"
            justifyContent="center"
            $isClickable={!!onClick}
            onClick={onClick}
        >
            {icon}
            <Text
                fontVariant={fontVariant}
                color={colorsPalettes.midnight[400]}
                data-automation="badge.text"
                flex="none"
            >
                {text}
            </Text>
        </StyledBadgeContainer>
    );
};

export default TagsBadge;
